import { Box, Em, Flex, Text } from '@workos-inc/design-system';
import * as React from 'react';
type DemoRootProps = React.ComponentProps<typeof Box>;
const DemoRoot: React.FC<DemoRootProps> = props => <Box my="6" {...props} data-sentry-element="Box" data-sentry-component="DemoRoot" data-sentry-source-file="demo.tsx" />;
type DemoContainerProps = React.ComponentProps<typeof Flex>;
const DemoContainer: React.FC<DemoContainerProps> = props => <Flex data-algolia-exclude align="center" className="DemoContainer" justify="center" p={{
  initial: '4',
  xs: '6',
  sm: '9'
}} tabIndex={-1} {...props} data-sentry-element="Flex" data-sentry-component="DemoContainer" data-sentry-source-file="demo.tsx" />;
type DemoCaptionProps = {
  children?: React.ReactNode;
};
const DemoCaption: React.FC<DemoCaptionProps> = ({
  children
}) => <Text align="center" as="p" mt="4" size="2" data-sentry-element="Text" data-sentry-component="DemoCaption" data-sentry-source-file="demo.tsx">
    <Em data-sentry-element="Em" data-sentry-source-file="demo.tsx">{children}</Em>
  </Text>;
export const Demo = {
  Root: DemoRoot,
  Container: DemoContainer,
  Caption: DemoCaption
};